import React, { useMemo } from "react";
import VStack from "../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing";
import { MockedAuthManager } from "../../contexts/AuthManager";
import WorkerDetails from "../../screens/client/WorkerDetails";
import { buildUser, buildWorkerInfo } from "../factories";
import { GET_WORKER_INFO, REMOVE_WORKER_FROM_CLIENT } from "../../graphql/core";
import type { Meta, StoryObj } from "@storybook/react";
import { createStackNavigator } from "@react-navigation/stack";

const Stack = createStackNavigator<{
    WorkerDetails: { workerId: string };
}>();

function StoryComponent() {
    const mocks = [
        {
            request: {
                query: GET_WORKER_INFO,
            },
            variableMatcher: () => true,
            newData: () => ({
                data: {
                    getWorkerInfo: buildWorkerInfo(),
                },
            }),
        },
        {
            request: {
                query: REMOVE_WORKER_FROM_CLIENT,
            },
            variableMatcher: () => true,
            newData: () => ({
                data: true,
            }),
        },
    ];
    const user = useMemo(buildUser, []);
    return (
        <MockedProvider mocks={mocks}>
            <MockedAuthManager user={user}>
                <VStack gap={1} style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}>
                    <Stack.Navigator initialRouteName="WorkerDetails">
                        <Stack.Screen
                            name="WorkerDetails"
                            component={WorkerDetails}
                            initialParams={{ workerId: "test" }}
                        />
                    </Stack.Navigator>
                </VStack>
            </MockedAuthManager>
        </MockedProvider>
    );
}

const meta = {
    title: "Screens/Worker details",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
